import Honeybadger from "@honeybadger-io/js";

const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === "production";

const honeybadger = Honeybadger.configure({
  apiKey: process.env.NEXT_PUBLIC_HONEYBADGER_API_KEY,
  environment: process.env.NEXT_PUBLIC_VERCEL_ENV ?? process.env.NODE_ENV,
  revision: process.env.NEXT_PUBLIC_HONEYBADGER_REVISION,
  reportData: isProduction,
  enableUnhandledRejection: true,
});

honeybadger.beforeNotify((notice) => {
  if (!notice) return;

  if (notice.message?.match(/Minified React error #\d+/)) {
    return false;
  }

  // Enrich all client-side notices with page context
  if (typeof window !== "undefined" && window.location) {
    notice.context = {
      ...notice.context,
      url: window.location.href,
      pathname: window.location.pathname,
      userAgent: navigator?.userAgent,
    };
  }

  // Tag network errors with more detail
  if (notice?.message?.match(/NetworkError|Failed to fetch|fetch/i)) {
    notice.context = {
      ...notice.context,
      errorCategory: "network",
    };
  }

  // Tag stream errors with more detail
  if (notice?.message?.match(/input stream|ReadableStream/i)) {
    notice.context = {
      ...notice.context,
      errorCategory: "stream",
    };
  }
});

export default honeybadger;
